import React, { useState, useRef } from 'react';
import { Modal, Form, Button, Spin, Input, notification } from 'antd';
import { PlusIcon } from '@heroicons/react/outline';
import usersService from '../../services/users';
import Errors from '../errors';

const CreateUser = ({ onUserCreated = () => {} }) => {
  const [modal, showModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const formRef = useRef();

  const handleSubmit = async () => {
    setLoading(true);
    await formRef.current.validateFields();
    try {
      const user = formRef.current.getFieldsValue();

      const response = await usersService.createUser(user);

      notification.open({ type: 'success', message: response.message, placement: 'bottomRight' });

      showModal(false);

      onUserCreated(response.user);

      formRef.current.resetFields();

      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification.open({
        type: 'error',
        message: 'Ocurrio un error al guardar el usuario',
        description: <Errors errors={error?.errors} />,
        placement: 'bottomRight'
      });
    }
  };

  return (
    <>
      <Button
        onClick={() => showModal(true)}
        className="flex items-center justify-center gap-1 text-white bg-cyan-500 hover:bg-cyan-600 hover:text-white focus:bg-cyan-700 focus:text-white font-medium transition mb-4 lg:mb-0"
        style={{ width: 150, height: 40 }}
      >
        Nuevo usuario <PlusIcon width={20} />
      </Button>
      <Modal
        visible={modal}
        title={<h1 className="text-lg">Nuevo usuario</h1>}
        width={700}
        footer={null}
        onCancel={() => showModal(false)}
      >
        <div className="mb-4">Por favor ingrese los campos solicitados.</div>
        <Form ref={formRef}>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: 'Por favor ingrese el nombre del usuario',
              },
            ]}
          >
            <Input placeholder="Nombre" size="large" />
          </Form.Item>
          <Form.Item
            name="username"
            rules={[
              { required: true, message: 'Por favor ingrese el usuario' },
            ]}
          >
            <Input placeholder="Usuario" size="large" />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                pattern:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Por favor ingrese un correo válido',
              },
            ]}
          >
            <Input placeholder="Email" size="large" type="email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Por favor ingrese la contreseña del usuario',
              },
            ]}
          >
            <Input.Password placeholder="Contraseña" size="large" />
          </Form.Item>
        </Form>
        <div className="flex justify-end gap-4">
          <Button onClick={() => showModal(false)}>Cancelar</Button>
          <Button
            type="primary"
            disabled={loading}
            onClick={() => handleSubmit()}
          >
            Guardar {loading && <Spin size="small" className="ml-2" />}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CreateUser;
